import React from 'react'

import PoweredBy from 'components/powered-by'
import FooterLinks from 'components/footer-links'

import styles from './styles.module.scss'

const BelowCta = () => {
  return (
    <div className={styles.footerLinks}>
      <PoweredBy className={styles.poweredBy} />
      <FooterLinks
        showTerms={false}
        linkClassName="neutral500"
        tooltipContentClassName={styles.tooltipContent}
        tooltipContainerClassName={styles.tooltipContainer}
      />
    </div>
  )
}

export default BelowCta
